
   var initialState = {
     open:false,
     info:{},
     openException:false,
     infoException:{},
     openDelete: false,
     openRestore: false,
     infoDelete: {},
     infoRestore: {}
     };
   
   const AlertReducer = (state = initialState, action) => {
     switch (action.type) {
       //-------Fetch-------//
       case "OPEN":
         return { ...state,open:true,info:action.payload};
        case "CLOSE":
            return { ...state,open:false};
            case "OPEN_EXCEPTION":
         return { ...state,openException:true,infoException:action.payload};
        case "CLOSE_EXCEPTION":
            return { ...state,openException:false};
            case "OPEN_DELETE":
              return { ...state, openDelete: true, infoDelete: action.payload };
            case "CLOSE_DELETE":
              return { ...state, openDelete: false };
            case "OPEN_RESTORE":
              return { ...state, openRestore: true, infoRestore: action.payload };
            case "CLOSE_RESTORE":
              return { ...state, openRestore: false };
       //----DEFAULT----//
       default:
         return state;
     }
   };
   export default AlertReducer;
   